export const profileData = {
  name: "Saugata Nath",
  role: "Web & Mobile Developer",
  location: "Karimganj, India",
  email: "saugatanath.in@gmail.com",
  heroTagline: "Think. Build. Repeat.",
  heroHeadline:
    "I build fast, scalable web and mobile applications with clean UI and modern technology.",
  footerHeadline: "Let us build your next digital product",
  footerDescription:
    "I create websites, web apps, and mobile apps that are fast, scalable, and user-focused. Reach out and let's discuss your idea.",
};

export type Project = {
  id: number | string;
  title: string;
  des: string;
  img: string;
  iconLists: string[];
  link: string;
  source?: "default" | "admin";
  createdAt?: string;
};

export const navItems = [
  { name: "Home", link: "#home" },
  { name: "About", link: "#about" },
  { name: "Projects", link: "#projects" },
  { name: "Skills", link: "#skills" },
  { name: "Contact", link: "#contact" },
];

export const gridItems = [
  {
    id: 1,
    title: "Saugata Nath",
    subtitle: "Full Stack & App Developer",
    description:
      "I'm a developer passionate about building modern digital products for web and mobile platforms. I focus on creating fast, scalable applications with clean UI, smooth user experiences, and reliable architecture.",
    className: "lg:col-span-7 lg:row-span-2 min-h-[420px]",
    imgClassName:
      "object-cover object-[center_16%] scale-[1.08] brightness-[0.88]",
    img: "/profile.svg",
  },
  {
    id: 2,
    title: "⚡ Experience",
    description:
      "Experience building full-stack web applications, dashboards, and digital products through freelance work and real-world projects.",
    className: "lg:col-span-5 lg:row-span-1 min-h-[198px]",
  },
  {
    id: 3,
    title: "🛠 My Core Tech Stack",
    description: "",
    className: "lg:col-span-5 lg:row-span-1 min-h-[198px]",
  },
  {
    id: 4,
    title: "🎓 Education",
    description:
      "Bachelor of Computer Applications (BCA) — Karimganj College. Currently pursuing my degree while building real-world projects and continuously improving my development skills.",
    className: "lg:col-span-6 lg:row-span-1 min-h-[180px]",
  },
  {
    id: 5,
    title: "🚀 What I Focus On",
    description:
      "I focus on building fast, scalable, and user-focused digital products that combine strong engineering with thoughtful design.",
    className: "lg:col-span-6 lg:row-span-1 min-h-[180px]",
  },
  {
    id: 6,
    title: "Have an idea in mind?",
    description: "Let's build something amazing together.",
    className: "lg:col-span-12 lg:row-span-1 min-h-[170px]",
  },
];

export const projects: Project[] = [
  {
    id: 1,
    title: "Project One",
    des: "A modern web app focused on performance, accessibility, and smooth user experience.",
    img: "/p1.svg",
    iconLists: ["/re.svg", "/tail.svg", "/ts.svg", "/three.svg", "/fm.svg"],
    link: "https://your-project-one.com",
  },
  {
    id: 2,
    title: "Project Two",
    des: "A collaboration-focused platform with real-time features and clean UX patterns.",
    img: "/p2.svg",
    iconLists: ["/next.svg", "/tail.svg", "/ts.svg", "/stream.svg", "/c.svg"],
    link: "https://your-project-two.com",
  },
  {
    id: 3,
    title: "Project Three",
    des: "A SaaS-style product with scalable architecture and production-ready integrations.",
    img: "/p3.svg",
    iconLists: ["/re.svg", "/tail.svg", "/ts.svg", "/three.svg", "/c.svg"],
    link: "https://your-project-three.com",
  },
  {
    id: 4,
    title: "Project Four",
    des: "An interaction-heavy website combining motion, 3D visuals, and responsive design.",
    img: "/p4.svg",
    iconLists: ["/next.svg", "/tail.svg", "/ts.svg", "/three.svg", "/gsap.svg"],
    link: "https://your-project-four.com",
  },
];

export const skills = [
  { id: 1, name: "JavaScript", icon: "/ja.svg" },
  { id: 2, name: "React", icon: "/re.svg" },
  { id: 3, name: "Next.js", icon: "/next.svg" },
  { id: 4, name: "TypeScript", icon: "/ts.svg" },
  { id: 5, name: "Tailwind CSS", icon: "/tail.svg" },
  { id: 6, name: "Three.js", icon: "/three.svg" },
  { id: 7, name: "Framer Motion", icon: "/fm.svg" },
  { id: 8, name: "GSAP", icon: "/gsap.svg" },
  { id: 9, name: "React Native", icon: "/re.svg" },
  { id: 10, name: "Flutter", icon: "/c.svg" },
];

export const testimonials: { quote: string; name: string; title: string }[] =
  [];

export const companies = [
  {
    id: 1,
    name: "cloudinary",
    img: "/cloud.svg",
    nameImg: "/cloudName.svg",
  },
  {
    id: 2,
    name: "appwrite",
    img: "/app.svg",
    nameImg: "/appName.svg",
  },
  {
    id: 3,
    name: "hostinger",
    img: "/host.svg",
    nameImg: "/hostName.svg",
  },
  {
    id: 4,
    name: "stream",
    img: "/s.svg",
    nameImg: "/streamName.svg",
  },
  {
    id: 5,
    name: "docker",
    img: "/dock.svg",
    nameImg: "/dockerName.svg",
  },
];

export const workExperience = [
  {
    id: 1,
    title: "Freelance Web & App Developer",
    time: "2024 — Present",
    desc: "Building custom web and mobile applications for different use cases, focusing on performance, scalability, and modern user experiences.",
    className: "md:col-span-2",
    thumbnail: "/exp2.svg",
  },
  {
    id: 2,
    title: "Developer — Unique Snapbox",
    time: "2023 — 2024",
    desc: "Worked on management systems and business platforms, building practical web applications and contributing to real-world production projects.",
    className: "md:col-span-2",
    thumbnail: "/exp1.svg",
  },
  {
    id: 3,
    title: "Web & App Product Builder",
    desc: "Creating modern digital products using React, Next.js, Tailwind CSS, React Native, and Flutter to ship scalable solutions.",
    className: "md:col-span-2",
    thumbnail: "/exp3.svg",
  },
  {
    id: 4,
    title: "BCA Student — Karimganj College",
    time: "2023 — Present",
    desc: "Currently pursuing a Bachelor of Computer Applications while building real-world projects and continuously improving my development skills.",
    className: "md:col-span-2",
    thumbnail: "/exp4.svg",
  },
];

export const socialMedia = [
  {
    id: 1,
    img: "/git.svg",
    alt: "GitHub",
    link: "https://github.com/Ataguass",
  },
  {
    id: 2,
    img: "/mail.svg",
    alt: "Email",
    link: "mailto:saugatanath.in@gmail.com",
  },
  {
    id: 3,
    img: "/twit.svg",
    alt: "Twitter",
    link: "https://x.com/saugataaa",
  },
  {
    id: 4,
    img: "/link.svg",
    alt: "LinkedIn",
    link: "https://www.linkedin.com/in/saugata-nath/",
  },
  {
    id: 5,
    img: "/insta.svg",
    alt: "Instagram",
    link: "https://www.instagram.com/saugataaa._",
  },
];
